var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueApexCharts',{attrs:{"type":"bar","height":"350","options":_vm.barChart.chartOptions,"series":_vm.barChart.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }